import $ from 'jquery';
import 'slick-carousel';

export default function slider() {

  function sliderHero() {
    $('.slider-hero').on('init afterChange', function(event, slick, currentSlide) {
      $('.slick-slide').each(function(index, slide) {
        const $slide = $(slide);
        const isHidden = $slide.attr('aria-hidden') === 'true';
        
        $slide.find('a, button, input, textarea, select, [tabindex]').each(function() {
          if (isHidden) {
            $(this).attr('tabindex', '-1');
          } else {
            $(this).removeAttr('tabindex');
          }
        });
      });
    });

    const sliderHeroOptions = {
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 1,
      fade: true,
      speed: 1000,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            fade: false
          }
        }
      ]
    };

    $('.slider-hero').slick(sliderHeroOptions);

    //se autoplay è attivo aggiungo il bottone play/pausa
    if (sliderHeroOptions.autoplay) {
      $('.slick-dots').append(`<button type="button" aria-label="Metti in pausa lo slider" id="toggle-pause-button" class="toggle-pause-pause"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="ico-svg"><path fill="currentColor" d="M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"/></svg></button>`);

      let isPlaying = true;

      $('#toggle-pause-button').on('click', function() {
        if (isPlaying) {
          $('.slider-hero').slick('slickPause');
          $(this).attr('aria-label', 'Avvia lo slider').children('.ico-svg').replaceWith(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="ico-svg"><path fill="currentColor" d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>`);
        } else {
          $('.slider-hero').slick('slickPlay');
          $(this).attr('aria-label', 'Metti in pausa lo slider').children('.ico-svg').replaceWith(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="ico-svg"><path fill="currentColor" d="M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"/></svg>`);
        }
        isPlaying = !isPlaying;
      });
    }
  }

  function sliderAppuntamenti() {
    $('.slider-appuntamenti').slick({
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: true,
            centerPadding: '15%',
          }
        }
      ]
    });
  }

  function sliderProgetti() {
    $('.slider-progetti').slick({
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: true,
            centerPadding: '15%',
          }
        }
      ]
    });
  }

  function sliderNewsImprese() {
    $('.slider-news-imprese').slick({
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerPadding: '15%',
          }
        }
      ]
    });
  }

  function sliderGuide() {
    $('.slider-guide').slick({
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerPadding: '15%',
          }
        }
      ]
    });
  }

  function sliderNewsDetail() {
    $('.slider-photogallery-detail').slick({
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      adaptiveHeight: true
    });
  }

  function sliderImpegno() {
    $('.slider-impegno').slick({
      arrows: false,
      dots: true,
      autoplay: false,
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: false
    });
  }
  
  $( document ).ready(function() {

    if($('.slider-hero').length > 0) {
      sliderHero();
    }

    if($('.slider-appuntamenti').length > 0) {
      sliderAppuntamenti();
    }

    if($('.slider-progetti').length > 0) {
      sliderProgetti();
    }

    if($('.slider-news-imprese').length > 0) {
      sliderNewsImprese();
    }

    if($('.slider-guide').length > 0) {
      sliderGuide();
    }

    if($('.slider-photogallery-detail').length > 0) {
      sliderNewsDetail();
    }

    if($('.slider-impegno').length > 0) {
      sliderImpegno();
    }
  });
}